import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../action";
import { DataType } from "constant";

import moment from "moment";

import { LicensesPath } from "routes/paths";

const LicensesActivityLogFilters = Object.freeze([
  {
    key: "productNumber",
    value: "Product Number",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const LicensesActivityLogs = ({ GetActivityLogs, history }) => {
  return (
    <div className="container-fluid">
      <h1>Licenses</h1>
      <Row>
        <ActivityLogs
          hasActivityFilter
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(LicensesPath)}
          activityLogFilters={LicensesActivityLogFilters}
          backButtonLabel={"View Licenses"}
          extraColumns={[
            {
              dataField: "productNumber",
              text: "Product Number",
              sort: true,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          extraSortColumns={{
            productNumber: 1,
          }}
          detailsModalHeader={[
            {
              label: "Product Number",
              value: "productNumber",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(LicensesActivityLogs);
